import React from 'react'

const LoadingCards = () => {
  return (
    <div className='md:col-span-2 h-full bg-white'>
        <div className='h-[140px] w-full bg-gray-200 shadow-xl py-1 rounded-xl animate-pulse mt-8'></div>
        <div className='h-[140px] w-full bg-gray-200 shadow-xl py-1 rounded-xl animate-pulse mt-8'></div>
        <div className='h-[140px] w-full bg-gray-200 shadow-xl py-1 rounded-xl animate-pulse mt-8'></div>
        <div className='h-[140px] w-full bg-gray-200 shadow-xl py-1 rounded-xl animate-pulse mt-8'></div>
        <div className='h-[140px] w-full bg-gray-200 shadow-xl py-1 rounded-xl animate-pulse mt-8'></div>
        <div className='h-[140px] w-full bg-gray-200 shadow-xl py-1 rounded-xl animate-pulse mt-8'></div>
    </div>
  )
}

export default LoadingCards